import { WorkflowReportState } from "@idw-types/state/workflow-report-state";
import { TimeRangeTypes } from "@enums/time-range-types";
import { getTimeRange } from "@utils/date-util";
import { WorkflowReportActionTypes, WorkflowReportActions } from "../actions/workflow-report-actions";

export const initialWorkflowReportState: WorkflowReportState = {
    searchFilters: {
        workflowId: null,
        appId: null,
        country: null,
        startDate: getTimeRange(TimeRangeTypes.CURRENT_MONTH).startDate,
        endDate: getTimeRange(TimeRangeTypes.CURRENT_MONTH).endDate,
        timeRangeType: TimeRangeTypes.CURRENT_MONTH,
        includeArchivedWorkflows: false
    },
    searchResults: {
        searchDate: null,
        isLoading: {
            passRatesAndPassRateOverTime: false,
            completionRates: false,
            completionRatesOverTime: false,
            stepByStep: false,
            fraud: false,
            volumesByAppID: false,
            volumesByCountry: false
        },
        passRates: null,
        passRatesOverTime: null,
        completionRates: null,
        completionRatesOverTime: null,
        stepByStep: null,
        fraud: null,
        volumesByAppID: null,
        volumesByCountry: null
    },
    metadataSearchFilters: {
        workflowId: null,
        startDate: null,
        endDate: null
    },
    metadataSearchResults: {
        searchDate: null,
        isLoading: false,
        appIDs: null,
        countries: null,
        rpServices: null
    },
    searchedMetadataSearchResults: {
        appIDs: null,
        countries: null,
        rpServices: null
    }
};

export const workflowReportReducer = (
    state: WorkflowReportState = initialWorkflowReportState,
    action: WorkflowReportActions
): WorkflowReportState => {
    switch (action.type) {
        // Search
        case WorkflowReportActionTypes.SET_WORKFLOW_REPORT_SEARCH_FILTERS:
            return {
                ...state,
                searchFilters: {
                    ...action.payload.searchFilters
                }
            };

        case WorkflowReportActionTypes.SET_PARTIAL_WORKFLOW_REPORT_SEARCH_RESULTS_LOADING:
            return {
                ...state,
                searchResults: {
                    ...state.searchResults,
                    isLoading: {
                        ...state.searchResults.isLoading,
                        [action.payload.dataType]: action.payload.isLoading
                    }

                }
            };

        case WorkflowReportActionTypes.SET_WORKFLOW_REPORT_SEARCH_RESULTS_PASS_RATE_AND_OVER_TIME:
            return {
                ...state,
                searchResults: {
                    ...state.searchResults,
                    searchDate: new Date(),
                    passRates: action.payload.passRates,
                    passRatesOverTime: action.payload.passRatesOverTime,
                    isLoading: {
                        ...state.searchResults.isLoading,
                        passRatesAndPassRateOverTime: false
                    }
                }
            };

        case WorkflowReportActionTypes.SET_WORKFLOW_REPORT_SEARCH_RESULTS_COMPLETION_RATE:
            return {
                ...state,
                searchResults: {
                    ...state.searchResults,
                    searchDate: new Date(),
                    completionRates: action.payload.completionRates,
                    isLoading: {
                        ...state.searchResults.isLoading,
                        completionRates: false
                    }
                }
            };
        case WorkflowReportActionTypes.SET_WORKFLOW_REPORT_SEARCH_RESULTS_COMPLETION_RATE_OVER_TIME:
            return {
                ...state,
                searchResults: {
                    ...state.searchResults,
                    searchDate: new Date(),
                    completionRatesOverTime: action.payload.completionRatesOverTime,
                    isLoading: {
                        ...state.searchResults.isLoading,
                        completionRatesOverTime: false
                    }
                }
            };
        case WorkflowReportActionTypes.SET_WORKFLOW_REPORT_SEARCH_RESULTS_STEP_BY_STEP:
            return {
                ...state,
                searchResults: {
                    ...state.searchResults,
                    searchDate: new Date(),
                    stepByStep: action.payload.stepByStep,
                    isLoading: {
                        ...state.searchResults.isLoading,
                        stepByStep: false
                    }
                }
            };

        case WorkflowReportActionTypes.SET_WORKFLOW_REPORT_SEARCH_RESULTS_VOLUME_BY_APP_ID:
            return {
                ...state,
                searchResults: {
                    ...state.searchResults,
                    searchDate: new Date(),
                    volumesByAppID: action.payload.volumesByAppID,
                    isLoading: {
                        ...state.searchResults.isLoading,
                        volumesByAppID: false
                    }
                }
            };


        case WorkflowReportActionTypes.SET_WORKFLOW_REPORT_SEARCH_RESULTS_VOLUME_BY_COUNTRY:
            return {
                ...state,
                searchResults: {
                    ...state.searchResults,
                    searchDate: new Date(),
                    volumesByCountry: action.payload.volumesByCountry,
                    isLoading: {
                        ...state.searchResults.isLoading,
                        volumesByCountry: false
                    }
                }
            };

        case WorkflowReportActionTypes.SET_WORKFLOW_REPORT_SEARCH_RESULTS_FRAUD:
            return {
                ...state,
                searchResults: {
                    ...state.searchResults,
                    searchDate: new Date(),
                    fraud: action.payload.fraud,
                    isLoading: {
                        ...state.searchResults.isLoading,
                        fraud: false
                    }
                }
            };

        // Metadata Search
        case WorkflowReportActionTypes.SET_WORKFLOW_REPORT_METADATA_SEARCH_FILTERS:
            return {
                ...state,
                metadataSearchFilters: {
                    ...action.payload.searchFilters
                }
            };
        case WorkflowReportActionTypes.SET_WORKFLOW_REPORT_METADATA_SEARCH_RESULTS_LOADING:
            return {
                ...state,
                metadataSearchResults: {
                    ...state.metadataSearchResults,
                    isLoading: action.payload.isLoading
                }
            };
        case WorkflowReportActionTypes.SET_WORKFLOW_REPORT_METADATA_SEARCH_RESULTS:
            return {
                ...state,
                metadataSearchResults: {
                    isLoading: false,
                    searchDate: new Date(),
                    ...action.payload.workflowReportMetadataSearchResults,
                }
            };
        case WorkflowReportActionTypes.SET_WORKFLOW_REPORT_SEARCHED_METADATA_SEARCH_RESULTS:
            return {
                ...state,
                searchedMetadataSearchResults: {
                    ...action.payload.workflowReportMetadataSearchResults
                }
            };
        default:
            return state;
    }
};